import * as Yup from 'yup';
import 'yup-phone-lite';
import { DealerEmailTemplate } from '../../../models/dealer.model';

Yup.setLocale({
  mixed: {
    required: 'Required Field',
  },
});

export const DealerSchema = Yup.object().shape({
  companyName: Yup.string().required().min(2).max(50),
  phone: Yup.string().phone('US', 'Please enter a valid phone number').required(),
  websiteUrl: Yup.string().optional().nullable(),
  customThemeContent: Yup.string().optional(),
  emailAddresses: Yup.array().of(Yup.string().required()).required(),
  emailTemplate: Yup.string().required().oneOf(Object.values(DealerEmailTemplate)),
  address: Yup.object().shape({
    addressLine1: Yup.string().required(),
    addressLine2: Yup.string().optional().nullable(),
    city: Yup.string().required(),
    state: Yup.string().required(),
    zipCode: Yup.string().required(),
  }),
  documents: Yup.array(
    Yup.object({
      fileName: Yup.string().required(),
      fileUrl: Yup.string().required(),
      uploadedBy: Yup.string(),
      uploadedBySub: Yup.string(),
      uploadedAt: Yup.number(),
    })
  ).default([]),
});

export const dealerInitialValues: any = {
  companyName: '',
  phone: '',
  websiteUrl: '',
  emailAddresses: [''],
  customThemeContent: '',
  emailTemplate: DealerEmailTemplate.Default,
  address: {
    addressLine1: '',
    addressLine2: '',
    city: '',
    state: '',
    zipCode: '',
  },
  documents: [],
};
